import WebComponent from 'fg-frontend/src/webComponents/WebComponent';
import Glide from '@glidejs/glide';

const fragments = {

};

class TileSlider extends WebComponent {
  constructor(props) {
    super(props);
    this.state = {};
  }
  didMount() {
    new Glide(this.element, TileSlider.defaultProps).mount();
  }
  willUnMount() {}
  update() {}
}

TileSlider.defaultProps = {
  perView: 2,
  gap: 24,
  breakpoints: {
    991: {
      perView: 1,
    },
  },
};

export default TileSlider;



// WEBPACK FOOTER //
// ./fe/web-default/src/js/components/TileSlider.js